<template>
	<div class="middleBox"> 
		<div class="stepForm"> 
			<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
			<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
			<div class="row" v-if="get_user.profile.risk_warning == 2 && get_user.profile.total_points >= 3 && get_user.profile.total_points <= 15">
				<div class="col-12">
					<div class="p-5 text-center">
						<div class="thumb mb-3">
							<img src="../../../../static/fxView/images/test_failed.svg" alt="Test Failed"  width="220">
						</div>
						<h3>{{$t('stepMsz6Title')}}</h3>
						<p v-html="$t('stepMsz6')"></p>
					</div>
				</div>
			</div>
			<div class="row" v-else-if="test_step == 0">
				<div class="col-12 mobPad">
					<h4 class="title mob-center pb-3 border-bottom text-left mb-4">{{$t('stepMsz4')}}</h4>
				</div>
				<div class="col-12 mobPad text-center">
					<div class="icon mb-5">
                        <img src="../../../../static/fxView/images/test.svg" alt="Email Support" width="220">
                    </div>
					<p class="mb-3">{{$t('stepMsz5')}}</p>
					<div class="row">
						<div class="col-12">
		                    <div class="	`">
		                        <button class="prism_btn btn_sm" v-on:click="startTestEvent">{{$t('startTest')}} </button>
		                    </div>
		                </div>
					</div>
				</div> 
			</div>
			<div class="row" v-else-if="test_step == 1">
				<div class="col-12 mobPad">
					<h4 class="title mob-center pb-3 border-bottom text-left mb-4">Do you have any experience related to investing in financial instruments?</h4>
					<ul class="twoColumn">
						<li v-for="(value, key) in isTradingExperience">
							<label class="customRadio-button">{{value}}
								<input type="radio" class="form-control" :id="key" name="TradingExperience" :value="key" v-model="is_trading_experience" v-validate="'required'" :disabled="disable" ref="is_trading_experienceInput" :class="{ 'is-invalid': submitted && errors.has('is_trading_experience') }" @focus="tradingExpEvent">
								<span class="checkmark"></span>
							</label>
						</li>
					</ul>
					<p class="error mb-3" v-if="submitted && errors.has('TradingExperience')">{{$t('fieldReq')}}</p>
				</div>
				<div class="col-12 mobPad">
					<div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
						<div class="leftbtn">
							<a href="#"  v-on:click="doitLaterEvent">{{$t('iDoLater')}}</a>
						</div>
						<button class="prism_btn btn_sm" v-on:click="startTest()">{{$t('saveContinue')}} </button>
					</div>
				</div>
			</div> 
			<div v-else-if="test_step == 2">
				<div class="col-12 mobPad question_answer" v-if="answerList.length > 0">
					<div class="col-12 mobPad" ref="question_form">
						<div class="d-flex align-items-center justify-content-between pb-3 border-bottom text-left mb-3">
							<h4 class="title">{{answerList[0].type}}</h4>
							<!-- <p class="qusNo mb-0">{{show_question + 1}} {{$t('Of')}} {{Object.keys(answer_list).length}}</p> -->
						</div>
					</div>
					<div v-for="(ques,index) in answerList">
						<h5 class="subtitle" :ref="ques.question_id+'questionInput'">{{ques.question}}</h5>
						<ul class="twoColumn">
							<li v-for="ans_list in ques.answers" :class="answer_Selected[ques.question_id] == ans_list.ans_id?'selected':''">
								<label class="customRadio-button">{{ans_list.answer}}
									<input type="radio" class="form-control" :id="ques.question_id" :name="ques.question_id+'question'" :value="ans_list.ans_id" v-model="answer_Selected[ques.question_id]" v-validate="answer_Selected[ques.question_id]?'':'required'" :disabled="disable" @focus="trackFzEvent(ques.sequence)">
									<span class="checkmark"></span>
								</label>
							</li>
						</ul>
						<p class="error mb-3" v-if="submitted && errors.has(ques.question_id+'question')">{{$t('fieldReq1')}}</p>
					</div>
					<div class="row">
						<!-- <div class="quesPercntBar col-12 mb-3" v-show="false">
							<span>{{progress_bar}}{{$t('percentComplete')}}</span>
							<div class="progressBar progress">
								 <div class="progress-bar" role="progressbar" v-bind:style="{ width: incWidth + '%' }"  aria-valuenow="15" aria-valuemin="0" aria-valuemax="100"></div>
							</div>
						</div> -->
						<div class="col-12">
		                    <div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
		                        <div class="leftbtn">
		                        	<button class="prism_btn btn_sm grayBtn" v-on:click="prevButtonEvent" v-if="testType == 'knowledge' && is_trading_experience == 2">{{$t('preQues')}}</button>
		                        	<button class="prism_btn btn_sm grayBtn" v-on:click="prevBtnEvent" v-else>{{$t('preQues')}}</button>
		                        </div>
								<button class="prism_btn btn_sm" v-on:click="next('next')" v-if="testType == 'trade' && is_trading_experience == 2">{{$t('nextQues')}}</button> 
								<button class="prism_btn btn_sm" v-on:click="next('save')" v-else>{{$t('saveContinue')}} </button>
		                    </div>
		                </div>
					</div>
				</div>
			</div>
			<div class="row alertResult" v-if="test_failed == 3">
				<div class="col-12 text-center">
					<div class="icon mb-5">
                        <img src="../../../../static/fxView/images/error.svg" alt="Lost" width="220">
                    </div>
					<p class="mb-3">{{$t('stepMsz7')}} </p>
					
					<div class="row">
						<div class="col-12">
							<div class="mobSubmit full-width border-top pt-3  mt-3 w-100">
		                    	<a href="#" v-on:click="doitLaterEvent"> {{$t('Cancel')}}<small> - or -</small> </a>
		                        <button class="prism_btn btn_sm" v-on:click="riskFunc()">{{$t('proceed')}}</button>
		                    </div>
		                </div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import * as types from '@/types'
    import { mapActions } from 'vuex'
    import { fxViewMixins } from '@/plugins/fxView'
	
    export default {
        name: 'stepThree',
        mixins: [fxViewMixins],
        data() {
            return {
            	response_msg : '',
                msg_type : '',
                pageLoader : false,
				ques_ans_array : [],
				step : 3,
				ques_ans_list : [],
				question_answer_key_array:[],
				submitted: false,
				show_question : 0,
				ques_id : '1',
				incWidth : 0,
				progress_bar : 0,
				test_step : 0,
				test_failed : -1,
				lastSelectedQuestionId: [],
				disable: false,
				answer_list : {},
				answer_Selected:[],
				is_trading_experience: 0,
				page: 1,
				// limit: 5
				// trading_ques_ans: [],
				// knowledge_ques_ans: [],
				testType:'knowledge',
				testTypeList:{
					'trade':'Trading Experience',
					'knowledge':'Knowledge',
				},
				

            }
        },
		computed:{
			answerList(){
				return Object.values(this.answer_list).filter(v=>this.testTypeList[this.testType] == v.type) || []
			}
		},
		methods:{
			riskFunc(){
                let user_json = this.get_user
				user_json.step = 4
				commit(types.SET_STATE, user_json)	
				localStorage.setItem('user', btoa(JSON.stringify(user)))
            },
			closeModalFunc(){
				this.$parent.$parent.showStepComponent = false
			},
			...mapActions({
                _runRegisterStepThree: types.RUN_REGISTER_STEP3,
				_runGetQuestionAnswer: types.RUN_GET_QUESTION_ANSWER
            }),
            next(event){
				console.log('testType',this.testType, this.is_trading_experience)
				if(event == 'next'){
					this.$trackEvent('CP+Client+Verification+6+Next');
					this.$trackEvent('CP+Client+Verification+7+Pageview');
				}else if(event == 'save'){
					this.$trackEvent('CP+Client+Verification+7+Next');
					this.$trackEvent('CP+Client+Verification+8+Pageview')
				}
            	const _that = this;
				_that.submitted = true;
				_that.$validator.validate().then(valid => {
					if(valid){
						_that.submitted = false;
            			if(_that.testType == 'trade' && _that.is_trading_experience == 2){
							_that.testType = 'knowledge'
							_that.$refs.question_form.scrollIntoView();
							return;
						} 
						_that.submit()

					}else{
						_that.handleValidationErrorAdvanced(_that.errors)
					}
				});
            	/*for (var i = 0; i < this.ques_ans_array.length; i++) {
					if(this.ques_ans_array[i] && this.ques_ans_array[i].question_id == questionid){
						
						this.lastSelectedQuestionId.push(questionid)

						this.show_question = parseInt(this.show_question) + 1
		            	this.incWidth += 10
		            	this.progress_bar += 10
		            	
					} 
				}*/
            },
            startTest(){
            	const _that = this;
				_that.submitted = true;
				_that.$validator.validate().then(valid => {
					if(valid){
						this.$trackEvent('CP+Client+Verification+5+Next')
						this.$trackEvent('CP+Client+Verification+6+Pageview')
            			_that.test_step += 1
						if(_that.is_trading_experience == 2){
            				_that.testType = 'trade'
						}else{
							_that.testType = 'knowledge'
						}
            		}
				});
            },
			submit(){
				if(this.disable){
                    let currentStep = this.get_user.step

                    if('tempStep' in this.get_user && currentStep < this.get_user.tempStep){
                        currentStep = this.get_user.tempStep
                    }
                    this.get_user.tempStep = currentStep
                    this.get_user.step = 4          
                    let user_json = this.get_user
                    this.$store.commit(types.SET_STATE, user_json)
                }else{
					// delete this.ques_ans_array[0]
					// let ques_ans_array = this.ques_ans_array.filter(val=>val)
					const _that = this
					_that.submitted = true;
					_that.$validator.validate().then(valid => {
						let newArr = []
						for(const key in _that.answer_list){
							if(_that.answer_list[key].answers && _that.answer_Selected[_that.answer_list[key].question_id]){
								newArr[key] = _that.answer_list[key].answers.find(v=>v.ans_id == _that.answer_Selected[_that.answer_list[key].question_id])
								// newArr.push(data)
							}
						}
						if (valid) {
							let input_json={
								'globalParams' :{
									'ques_ans_array': newArr,
									'is_trading_experience':_that.is_trading_experience,
									'step' : _that.step,
								},
								'localParams' :{
									"parameter" : _that
								}
							}
							_that._runRegisterStepThree(input_json)
						}else{
							console.log("submited")
							_that.handleValidationErrorAdvanced(_that.errors)
						}
					});
				}
			},
			getStep(){
				this._runGetUserRegisterationStepData({'globalParams' :{},'localParams' :{ "parameter" : this , "step" : '3'}})
			},
			startTestEvent(){
				this.test_step = 1
				this.$trackEvent('CP+Client+Verification+4+Start')
				this.$trackEvent('CP+Client+Verification+5+Pageview')
			},
			doitLaterEvent(){
				this.$trackEvent('CP+Client+Verification+5+Later');
				this.$parent.do_later = true
			},
			tradingExpEvent(){
				this.$trackEvent('CP+Client+Verification+5+Experince');
			},
			trackFzEvent(eventName){
				switch(eventName){
					case 0: 
						this.$trackEvent('CP+Client+Verification+6+Share+Trades');
					break;
					case 1:
						this.$trackEvent('CP+Client+Verification+6+Futures+Trades');
					break;
					case 2:
						this.$trackEvent('CP+Client+Verification+6+FX+Trades');
					break;
					case 3:
                        this.$trackEvent('CP+Client+Verification+6+CFD+Volume');
					break;
					case 4:
                        this.$trackEvent('CP+Client+Verification+6+Strategy');
					break;
					case 5:
                        this.$trackEvent('CP+Client+Verification+6+CFD+MM');
					break;
					case 6:
                        this.$trackEvent('CP+Client+Verification+7+Leverage');
					break;
					case 7:
                        this.$trackEvent('CP+Client+Verification+7+PL');
					break;
					case 8:
						this.$trackEvent('CP+Client+Verification+7+SL');
					break;
					case 9:
						this.$trackEvent('CP+Client+Verification+7+CFD');
					break;
				}
			},
			prevButtonEvent(){
				this.testType = 'trade'
				this.$trackEvent('CP+Client+Verification+7+Back');
			},
			prevBtnEvent(){
				this.test_step = 1
				this.$trackEvent('CP+Client+Verification+6+Back');
			}
		},
		created(){
			// this.$trackEvent('CP+Client+Verification+4+Pageview')
			const _that = this
			_that._runGetQuestionAnswer({'globalParams' :{},'localParams' :{"parameter" : _that}})
			if(parseInt(this.get_user.profile.ipv_status)){
                _that.disable = true;
            }
			// window.setTimeout(_that._runGetUserRegisterationStepData({'globalParams' :{},'localParams' :{ "parameter" : _that , "step" : '3'}}), 5000)
			
		}
    }
</script>
<style scoped>
	.form-control:disabled, .form-control[readonly]{
		opacity: 0 !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/step3.vue